'use client';

import { AccountWeb3 as Section } from '../../components/UserProfile/AccountSections';
import { createSection } from '../createSection';

export const UserProfileWeb3Section = createSection('UserProfileWeb3Section', Section);
